import React, { FC } from 'react';
import classnames from 'classnames';
import { QuestionIconProps } from './props';
import './styles.scss';

export const QuestionIcon: FC<QuestionIconProps> = ({ className }) => {
  return <span className={classnames('frank-question-icon', className)}>?</span>;
};
